import Vue from 'vue';
import Vuex from 'vuex';

import { createProvider } from '../vue-apollo'

// MOCK DATA
import { EMPTY_POLL } from '../sample/Poll.js'

Vue.use(Vuex);

export const apollo = createProvider()

const removeUnusedStringOnExceptions = (e) => Error(e.message.replace('GraphQL error: ', ""));

export default new Vuex.Store({
  state: {
    poll: EMPTY_POLL,
    pollManage: undefined,
    projectSources: [],
    pollUnselectedProjects: [],
    pollSelectedProjects: [],
    pollOpportunityQuestions: null, // [ ]
    // ----- PUBLIC VIEW
    publicPoll: undefined,
    publicProjectAnswers: [],
    publicProjectQuestionAnswers: [],
    publicProjectEvaluations: [],
    pollProjects: [],
    pollPublicProjects: [],
    project: undefined,
  },
  // ------------------------------------------------------
  // ----------------- DATA MUTATIONS ---------------------
  // ------------------------------------------------------
  mutations: {
    setPoll(state, poll) {
      if (!poll) {
        // INITIALIZE EMPTY POLL
        state.poll = EMPTY_POLL
        return
      }
      state.poll = poll
    },
    setPollManage(state, value) {
      state.pollManage = value ? value : null
    },
    setPublicPoll(state, value) {
      state.publicPoll = value ? value : undefined
    },
    setPublicProjectAnswers(state, value) {
      state.publicProjectAnswers = value ? value : undefined
    },
    setPublicProjectQuestionAnswers(state, value) {
      state.publicProjectQuestionAnswers = value ? value : undefined
    },
    setPublicProjectEvaluations(state, value) {
      state.publicProjectEvaluations = value ? value : undefined
    },
    // ------- POLL DATA
    updatePageType(state, value) {
      state.poll.data.pageType = value
    },
    updateName(state, value) {
      state.poll.data.name = value
    },
    updateDescription(state, value) {
      state.poll.data.description = value
    },
    updateVisualIdentity(state, value) {
      if (!state.poll.data.photos) {
        state.poll.data.photos = {}
        state.poll.data.photos['visualIdentity'] = value
      } else {
        state.poll.data.photos.visualIdentity = value
      }
    },
    updateSlider(state, value) {
      if (!state.poll.data.photos) {
        state.poll.data.photos = {}
        state.poll.data.photos['slider'] = value
      } else {
        state.poll.data.photos.slider = value
      }
    },
    // ------- POLL PROJECT
    resetProjectLists(state) {
      state.pollUnselectedProjects = [];
      state.pollSelectedProjects = [];
    },
    resetProjectSources(state) {
      state.projectSources = [];
    },
    updateSourceOfProjects(state, value) {
      state.poll.project.sourceOfProjects = value ? value : null
    },
    updateSelectedContestId(state, value) {
      state.poll.project.selectedContestId = value ? value : null
    },
    updateSelectedProjectsInput(state, value) {
      // List of Projects id
      state.poll.project.listOfSelectedProjects = value ? value : []
    },
    setProjectSources(state, value) {
      state.projectSources = value ? value : []
    },
    setUnselectedProjects(state, value) {
      // List of Projects data
      state.pollUnselectedProjects = value ? value : [];
    },
    setSelectedProjects(state, value) {
      // List of Projects data
      state.pollSelectedProjects = value ? value : [];
    },
    setOpportunityQuestions(state, value) {
      // List of Projects data
      state.pollOpportunityQuestions = value ? value : [];
    },
    // ------- POLL CONFIG
    updatePublicationDate(state, value) {
      state.poll.configuration.publicationDate = value ? value : null
    },
    updateDeadlineForVotingOnProjectsFrom(state, value) {
      if (!state.poll.configuration.deadlineForVotingOnProjects)
        state.poll.configuration.deadlineForVotingOnProjects = {}
      state.poll.configuration.deadlineForVotingOnProjects['from'] = value ? value : null
    },
    updateDeadlineForVotingOnProjectsTo(state, value) {
      if (!state.poll.configuration.deadlineForVotingOnProjects)
        state.poll.configuration.deadlineForVotingOnProjects = {}
      state.poll.configuration.deadlineForVotingOnProjects['to'] = value ? value : null
    },
    updateCustomLink(state, value) {
      state.poll.configuration.customLink = value ? value : null
    },
    clearProjectDataForDisplay(state, body) {
      const projectDataForDisplay = state.poll.configuration.projectDataForDisplay
      for (const key in projectDataForDisplay) {
        if (Array.isArray(projectDataForDisplay[key])) {
          projectDataForDisplay[key] = []
        } else {
          projectDataForDisplay[key] = false
        }
      }
    },
    updateProjectDataForDisplay(state, body) {
      // body {
      //   attrName
      //   attrValue
      // }
      const { attrName, attrValue } = body;
      if (!state.poll.configuration.projectDataForDisplay) {
        state.poll.configuration.projectDataForDisplay = {}
      }
      if (!state.poll.configuration.projectDataForDisplay.questions) {
        state.
          poll.configuration.projectDataForDisplay.questions = []
      }
      if (attrName == 'questions') {
        state.poll.configuration.projectDataForDisplay.questions.push(attrValue)
      } else {
        state.poll.configuration.projectDataForDisplay[attrName] = attrValue;
      }

    },
    updateScoreAsPrivate(state, value) {
      state.poll.configuration.scoreAsPrivate = value ? value : false
    },
    updateVoteLimitPerEmail(state, value) {
      const voteLimit = Number(value)
      state.poll.configuration.voteLimitPerEmail = (voteLimit && voteLimit > 0) ? voteLimit : null
    },
    updateVotingRestrictionByEmail(state, value) {
      state.poll.configuration.votingRestrictionByEmail = (value && value.length > 0) ? value : null
    },
    // ------- DRAFT FLAG
    setDraft(state, value) {
      if (typeof value !== 'boolean') return
      state.poll.isDraft = value;
    },
    // ------- PROJECTS
    setPollProjects(state, value) {
      // List of Projects main data
      if (!value)
        state.pollProjects = [];
      else
        state.pollProjects = value;
    },
    // ------- PUBLIC PROJECTS
    setPollPublicProjects(state, value) {
      // List of Projects main data
      if (!value)
        state.pollPublicProjects = [];
      else
        state.pollPublicProjects = value;
    },
    setPollProject(state, value) {
      // Project all data
      if (!value)
        state.project = undefined;
      else
        state.project = value;
    },
    // -------- PROJECT INDIVIDUAL
    incrementProjectVote(state) {
      const project = state.project;
      if (!project) return;

      state.project.totalVotes += 1;
    }
  },
  // ------------------------------------------------------
  // -------------------- ACTIONS -------------------------
  // ------------------------------------------------------
  actions: {
    async getAllPolls(context) {
      const res = await apollo.defaultClient.query({
        query: require('../graphql/getAllPolls.gql'),
      })
      const polls = res.data.listConfiguration

      return polls
    },
    // ------- POLL MANAGE
    async getPollManage(context, body) {
      // body {
      //   pollId
      // }

      const { pollId } = body;
      if (!pollId) { // GOTTA BE THE FIRST CHECK
        context.commit('setPollManage', null); // NO POLL
        return; // Return as quick as possible
      }

      var res = await apollo.defaultClient.query({
        query: require('../graphql/getPollManage.gql'),
        variables: {
          id: pollId
        }
      });
      context.commit('setPollManage', res);
      const poll = res.data.managementPanelData;

      if (!poll || poll.isDraft) {
        context.commit('setPollManage', null); // NOT FOUND
        return
      }
      context.commit('setPollManage', poll);
    },
    async getManagementProjects(context, body) {
      // @param body { pollId }

      const { pollId } = body;
      if (!pollId) { // GOTTA BE THE FIRST CHECK
        context.commit('setSelectedProjects', null); // NO POLL
        return; // Return as quick as possible
      }

      var res = await apollo.defaultClient.query({
        query: require('../graphql/getManagementProjects.gql'),
        variables: {
          pollId: pollId
        }
      });
      const projects = res.data.managementSelectedProjects;
      if (!projects) {
        context.commit('setSelectedProjects', null); // NOT FOUND
        return
      }
      context.commit('setSelectedProjects', projects);
    },
    // ------- POLL CONFIGURATION
    async getPollConfiguration(context, body) {
      // body {
      //   pollId
      // }

      const { pollId } = body
      // GOTTA BE THE FIRST CHECK
      if (!pollId) { // It is a new poll
        context.commit('setPoll', null)
        return // Return as quick as possible
      }

      let res = await apollo.defaultClient.query({
        query: require('../graphql/getPollConfiguration.gql'),
        variables: {
          id: pollId
        }
      });

      const poll = res.data.getConfiguration

      if (!poll) {
        context.commit('setPoll', null)
        return
      }

      // TODO: Maybe move to its component
      if (poll.project && poll.project.sourceOfProjects) {
        context.dispatch('fetchProjectSources', {
          sourceType: poll.project.sourceOfProjects
        });
      }
      context.dispatch('fetchUnselectedProjects', {
        pollId: poll.id,
        sourceType: poll.project.sourceOfProjects,
        sourceId: poll.project.selectedContestId,
        filters: null
      });
      context.dispatch('fetchSelectedProjects', {
        pollId: poll.id,
        sourceType: poll.project.sourceOfProjects,
        sourceId: poll.project.selectedContestId
      });

      // Get Questions
      const { sourceType, sourceId } = {
        pollId: poll.id,
        sourceType: poll.project.sourceOfProjects,
        sourceId: poll.project.selectedContestId
      }
      if (!pollId || !sourceType || !sourceId) { // Only can get questions of a valid poll
        context.commit('setOpportunityQuestions', [])
      } else {
        res = await apollo.defaultClient.query({
          query: require('../graphql/getOpportunityQuestions.gql'),
          variables: {
            pollId: pollId,
            sourceType: sourceType,
            sourceId: sourceId
          }
        })
        const questions = res.data.listOpportunityQuestions;
        context.commit('setOpportunityQuestions', questions ? questions : [])
      }
      // Set Poll to last to prevent race condition
      context.commit('setPoll', poll);
    },
    async savePoll(context) {
      const poll = context.state.poll
      if (!poll) {
        return;
      }

      let res = null;
      res = await apollo.defaultClient.mutate({
        mutation: require('../graphql/savePollConfiguration.gql'),
        variables: {
          input: poll
        }
      });
      poll.id = res.data.saveConfiguration.id;
      context.commit("setPoll", poll)
    },
    // ------- POLL CONFIGURATION ( PROJECT )
    async updateSourceOfProjects(context, body) {
      /*  Responsible for UPDATING/SETTING the poll.selectedContestId (sourceID)
          and FETCH projects within this source. 
          All of them is gonna be reflected in any componet that maps those states
      @param body { sourceType }
       */
      context.commit('resetProjectSources')
      context.commit('resetProjectLists')
      context.commit('updateSelectedProjectsInput', null)

      const { sourceType } = body;
      if (!sourceType) {
        context.commit('updateSourceOfProjects', null)
        return;
      }
      context.commit('updateSourceOfProjects', sourceType)
      context.dispatch('fetchProjectSources', body)
    },
    async fetchProjectSources(context, body) {
      // @param body { sourceType }

      const { sourceType } = body;
      if (!sourceType) {
        context.commit('setProjectSources', [])
        return;
      }

      let sources = [];
      if (sourceType === 'OPPORTUNITY') {
        const res = await apollo.defaultClient.query({
          query: require('../graphql/getOpportunities.gql')
        });
        sources = res.data.listOpportunities;

      } else if (sourceType === 'MONITOR') {
        const res = await apollo.defaultClient.query({
          query: require('../graphql/getMonitors.gql')
        });
        sources = res.data.listMonitors;
      }
      if (!sources) {
        context.commit('setProjectSources', [])
      } else {
        context.commit('setProjectSources', sources)
      }
    },
    async updateSelectedContestId(context, body) {
      /*  Responsible for UPDATING/SETTING the poll.selectedContestId (sourceID)
          and FETCH projects within this source. 
          All of them is gonna be reflected in any componet that maps those states
      @param body {
        pollId
        sourceType
        sourceId (idOfProjectOrMonitor)
        filters {
          pageIndex
          offset
          actualPage
          name
          tags
          status
        }
      }
      */

      context.commit('resetProjectLists')
      context.commit('updateSelectedProjectsInput', null)

      const { sourceType, sourceId } = body;
      if (!sourceType || !sourceId) {
        context.commit('setUnselectedProjects', []);
        return;
      }
      context.commit('updateSelectedContestId', sourceId)
      context.dispatch(
        'fetchUnselectedProjects', {
        pollId: null, sourceType: sourceType, sourceId: sourceId, filters: null
      }
      )
    },
    async fetchUnselectedProjects(context, body) {
      // @param body {
      //   pollId
      //   sourceType
      //   sourceId (idOfProjectOrMonitor)
      //   filters {
      //     pageIndex
      //     offset
      //     actualPage
      //     name
      //     tags
      //     status
      //   }
      // }

      const { pollId, sourceType, sourceId, filters } = body;
      if (!sourceType || !sourceId) {
        context.commit('setUnselectedProjects', []);
        return;
      }

      if (!filters) {
        return context.dispatch('getAllProjectsWithinSource', { pollId, sourceType, sourceId })
      }

      const { pageIndex, offset, actualPage, name, tags, status } = filters;
      // TODO: Define status on GraphQL Query
      var res = await apollo.defaultClient.query({
        query: require('../graphql/getUnselectedProjects.gql'),
        variables: {
          input: {
            id: pollId,
            type: sourceType,
            idOfOpportunityOrMonitor: sourceId,
            name: name,
            tag: tags,
            status: status,
            page: pageIndex,
            offset: offset,
            actualPage: actualPage
          }
        }
      });
      const unselectedProjects = res.data.listUnselectedProjects;
      if (!unselectedProjects) {
        context.commit('setUnselectedProjects', []);
        return;
      }

      context.commit('setUnselectedProjects', unselectedProjects);
    },
    async fetchSelectedProjects(context, body) {
      // @param body { pollId, sourceType, sourceId }

      const { pollId, sourceType, sourceId } = body;
      if (!pollId || !sourceType || !sourceId) { // Only can get selected projects of a valid poll
        context.commit('setSelectedProjects', [])
        return // Return as quick as possible
      }

      let res = undefined;
      try {
        res = await apollo.defaultClient.query({
          query: require('../graphql/getSelectedProjects.gql'),
          variables: {
            pollId: pollId,
            sourceType: sourceType,
            sourceId: sourceId
          }
        })
      } catch (err) {
        throw err
      }
      const projects = res.data.listSelectedProjects;

      if (!projects || projects.length === 0) {
        context.commit('setSelectedProjects', [])
        return
      }
      context.commit('setSelectedProjects', projects)
    },
    async getAllProjectsWithinSource(context, body) {
      // @param body {
      //   pollId
      //   sourceType
      //   sourceId (idOfProjectOrMonitor)
      // }
      const { pollId, sourceType, sourceId } = body
      var res = await apollo.defaultClient.query({
        query: require('../graphql/getUnselectedProjects.gql'),
        variables: {
          input: {
            id: pollId,
            type: sourceType,
            idOfOpportunityOrMonitor: sourceId,
            name: null,
            tag: null,
            status: null,
            page: null,
            offset: null,
            actualPage: null
          }
        }
      });
      const unselectedProjects = res.data.listUnselectedProjects;

      if (!unselectedProjects) {
        context.commit('setUnselectedProjects', []);
        return;
      }
      context.commit('setUnselectedProjects', unselectedProjects);
    },
    // ------- PUBLIC VIEW
    async getPublicPoll(context, body = {}) {
      // @param body: NOTHING ON THIS
      let { domain } = body;
      var res = await apollo.defaultClient.query({
        query: require('../graphql/getPublicPoll.gql'),
        variables: {
          domain
        }
      });
      const poll = res.data.getPublicConfiguration;
      if (!poll) {
        context.commit('setPublicPoll', undefined);
      }
      context.commit('setPublicPoll', poll);
    },
    async getPublicProjectAnswers(context, body) {
      let { projectId, domain } = body;
      projectId = Number(projectId);

      if (!projectId) {
        context.commit('setPollProject', undefined);
        return;
      }
      var res = await apollo.defaultClient.query({
        query: require('../graphql/getPublicProjectAnswers.gql'),
        variables: {
          projectId: projectId,
          domain
        }
      });
      const poll = res.data.listPublicProjectAnswers;
      if (!poll) {
        context.commit('setPublicProjectAnswers', undefined);
      }
      context.commit('setPublicProjectAnswers', poll);
    },
    async getPublicProjectQuestionAnswers(context, body) {
      let { projectId, domain } = body;
      projectId = Number(projectId);

      if (!projectId) {
        context.commit('setPollProject', undefined);
        return;
      }
      var res = await apollo.defaultClient.query({
        query: require('../graphql/getPublicProjectQuestionAnswers.gql'),
        variables: {
          projectId: projectId,
          domain
        }
      });
      const poll = res.data.listPublicProjectQuestionAnswers;
      if (!poll) {
        context.commit('setPublicProjectQuestionAnswers', undefined);
      }
      context.commit('setPublicProjectQuestionAnswers', poll);
    },
    async getPublicProjectEvaluations(context, body) {
      let { projectId, domain } = body;
      projectId = Number(projectId);

      if (!projectId) {
        context.commit('setPollProject', undefined);
        return;
      }
      var res = await apollo.defaultClient.query({
        query: require('../graphql/getPublicProjectEvaluations.gql'),
        variables: {
          projectId: projectId,
          domain
        }
      });
      const poll = res.data.listPublicProjectEvaluations;
      if (!poll) {
        context.commit('setPublicProjectEvaluations', undefined);
      }
      context.commit('setPublicProjectEvaluations', poll);
    },
    async getAllPublicProjects(context, body = {}) {
      let { domain } = body;
      var res = await apollo.defaultClient.query({
        query: require('../graphql/getAllPublicProjects.gql'),
        variables: {
          domain
        }
      });
      const projects = res.data.listPublicSelectedProjects;
      if (!projects) {
        context.commit('setPollPublicProjects', undefined);
        return;
      }
      context.commit('setPollPublicProjects', projects);
    },
    async getProjectData(context, body) {
      let { projectId, domain } = body;
      projectId = Number(projectId);

      if (!projectId) {
        context.commit('setPollProject', undefined);
        return;
      }

      var res = await apollo.defaultClient.query({
        query: require('../graphql/getProjectData.gql'),
        variables: {
          projectId: projectId,
          domain
        }
      });
      const project = res.data.getPublicProject;

      if (!project) {
        context.commit('setPollProject', undefined);
        return;
      }
      context.commit('setPollProject', project);
    },
    async makeVote(context, body) {
      // @param body { email, projectId }

      const { email, projectId, domain } = body;
      if (!email || !projectId)
        return // must have a email
      let res = null;
      try {
        res = await apollo.defaultClient.mutate({
          mutation: require('../graphql/makeVote.gql'),
          variables: {
            email: email,
            projectId: projectId,
            domain
          }
        });
      } catch (e) {
        throw removeUnusedStringOnExceptions(e);
        // TODO: Gotta inform that poll has not been saved
      }
      return true
    },
    async validateVoteToken(context, body) {
      // @param body { token }

      const { token, domain } = body;
      if (!token)
        return // must have a token

      let res = null;
      try {
        res = await apollo.defaultClient.mutate({
          mutation: require('../graphql/validateVoteToken.gql'),
          variables: {
            token: token,
            domain
          }
        });
      } catch (e) {
        throw removeUnusedStringOnExceptions(e);
      }
      return true
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js